import React from "react";
import img1 from "../../assets/images/b-1.png";
import img2 from "../../assets/images/b-2.png";
import img3 from "../../assets/images/b-3.png";
import { motion } from "framer-motion";
import "aos/dist/aos.css";
import AOS from "aos";
const BlogPosts = () => {
  AOS.init();

  return (
    <div id="blog" className=" pt-20 ">
      <div className="pt-2 MyContainer relative after:absolute after:content-['Blog']  after:tracking-widest after:text-own-gray-black after:text-[6rem]   sm:after:text-[8rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] after:-top-[35px] after:-z-10 text-center">
        <span className="bg-own-primary bg-opacity-50 px-6 text-xl tracking-wide  my-10 py-2 inline-block text-own-gray-white border-b-[2px] border-own-border-color border-opacity-10 animate-bounce">
          Featured Blog post
        </span>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-6 text-left">
          <div
            data-aos="zoom-in-up"
            className="bg-own-primary   rounded-xl border-[1px] border-own-border-color border-opacity-10 flex flex-col  p-3"
          >
            <div>
              <img className="w-full h-[230px] mb-4" src={img1} alt="" />
            </div>
            <div className="">
              <h2 className="text-2xl  font-medium mb-1 text-own-gray-white">
                A life without the daily traffic jams and{" "}
              </h2>
              <h3 className="font-bold mb-1 text-own-gray-white">
                Post On <span className="text-own-secondary">24.11.19</span> By{" "}
                <span className="text-own-secondary">ThemeSpiders</span>
              </h3>
              <p className="text-own-ternary mb-2">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout
              </p>
              <button className="btn-animated">Read More</button>
            </div>
          </div>
          <div
            data-aos="zoom-in-up"
            className="bg-own-primary   rounded-xl border-[1px] border-own-border-color border-opacity-10 flex flex-col p-3"
          >
            <div className="">
              <img className="w-full h-[230px] mb-4" src={img2} alt="" />
            </div>
            <div className="">
              <h2 className="text-2xl  font-medium mb-1 text-own-gray-white">
                Proportion are what’s really needed okay
              </h2>
              <h3 className="font-semibold mb-1 text-own-gray-white">
                Post On <span className="text-own-secondary">24.11.19</span> By{" "}
                <span className="text-own-secondary">ThemeSpiders</span>
              </h3>
              <p className="text-own-ternary mb-2">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout
              </p>
              <button className="btn-animated">Read More</button>
            </div>
          </div>
          <div
            data-aos="zoom-in-up"
            className="bg-own-primary flex  rounded-xl border-[1px] border-own-border-color border-opacity-10  flex-col p-3"
          >
            <div className="">
              <img className="w-full h-[230px]" src={img3} alt="" />
            </div>
            <div className="p-3">
              <h2 className="text-2xl  font-medium mb-1 text-own-gray-white">
                Mounts of paper work to remember the way
              </h2>
              <h3 className="font-bold mb-1 text-own-gray-white">
                Post On <span className="text-own-secondary">24.11.19</span> By{" "}
                <span className="text-own-secondary">ThemeSpiders</span>
              </h3>
              <p className="text-own-ternary mb-2">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout
              </p>
              <button className=" btn-animated ">Read More</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPosts;
